import { ApiError } from 'services/api';
import { createContext, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useOrgAuthMethods, useUpdateOrgAuthMethods } from 'api/AuthenticationPolicyAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import noop from 'utils/noop';
import { GOOGLE_SIGNIN, SAML_METADATA, SAML_DOMAIN, SSO, USERNAME_PASSWORD } from '../constants';

const defaultValue = {
  isLoading: false,
  isUpdating: false,
  updateOrgAuthMethods: noop as any,
  [GOOGLE_SIGNIN]: false,
  [SSO]: false,
  [USERNAME_PASSWORD]: false,
  [SAML_DOMAIN]: '',
  [SAML_METADATA]: '',
};

export const AuthenticationQueryContext = createContext(defaultValue);

export const AuthenticationQueryContextProvider = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const { data = {}, refetch, isLoading } = useOrgAuthMethods();
  const { mutate: updateOrgAuthMethods, isLoading: isUpdating } = useUpdateOrgAuthMethods({
    onSuccess: () => {
      dispatch(addPositiveToast('Success! Updated authentication policy.'));
      refetch();
    },
    onError: (error: unknown) => {
      const msg =
        (error as ApiError)?.response?.data?.message || 'Something went wrong. Please try again.';
      dispatch(addNegativeToast(msg));
    },
  });

  const value = {
    isLoading,
    isUpdating,
    updateOrgAuthMethods,
    ...data,
  };

  return (
    <AuthenticationQueryContext.Provider value={value}>
      {children}
    </AuthenticationQueryContext.Provider>
  );
};

export const useAuthenticationQueryContext = () => useContext(AuthenticationQueryContext);
